import { ReactNode } from 'react';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface FeedbackButtonProps {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  isSelected?: boolean;
  disabled?: boolean;
}

/**
 * FeedbackButton Component
 * 
 * Single feedback button (positive or negative).
 * 
 * Design specs:
 * - Layout: flex-1
 * - Border: 2px solid #C7EDEF (Lighter Blue)
 * - Border radius: 8px
 * - Padding: 16px
 * - Layout: flex column, gap 4px
 * 
 * Icon: 24x24px, fill #1B2831
 * Text: DM Sans SemiBold, responsive 14px→15px→16px
 */
export default function FeedbackButton({ 
  icon, 
  label, 
  onClick,
  isSelected = false,
  disabled = false
}: FeedbackButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex-1 flex flex-col items-start gap-1"
      style={{
        backgroundColor: isSelected ? ACTIVITY_DETAILS_COLORS.lightestBlue : ACTIVITY_DETAILS_COLORS.white,
        border: `2px solid ${ACTIVITY_DETAILS_COLORS.feedbackBorder}`,
        borderRadius: `${ACTIVITY_DETAILS_RADIUS.button}px`,
        padding: '16px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'background-color 0.2s ease, opacity 0.2s ease',
      }}
    >
      {icon}
      <span
        className={`font-semibold text-left ${ACTIVITY_DETAILS_TYPOGRAPHY.feedbackButtonLabel}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.textPrimary,
        }}
      >
        {label}
      </span>
    </button>
  );
}
